export const localizationApi = {
  getMessages: (locale) =>
    new Promise((resolve) => {
      import(`messages/${locale}/strings.json`).then((module) => resolve(module.default));
    }),
};
